import { createFeatureSelector } from '@ngrx/store'
import { StoreKeysEnum } from '../../../store/store-keys'
import { ILpisKulturasState } from './lpis-kultura.reducer'

export const selectLpisKulturas = createFeatureSelector<Readonly<ILpisKulturasState>>(StoreKeysEnum.LpisKulturas)
